import React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useSnackbar } from 'notistack';
import DetailedTable from '../../components/DetailedTable';
import { Button } from '@material-ui/core';
import { Loading } from '../../Loading';
import AddTestRules from './AddTestRules';
import { Edit, Trash } from '@jda/lui-common-icon-library';
import { WORKFLOW_LIST, GET_TEST_RULES, DELETE_TEST_RULES } from '../graphQL/queries';
import { testRulescolumns } from './CertificationConfic';
import useStyles from './Style';

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};

type workflowContentData = {
  content: workflowInfo[];
};

type ruleInfo = {
  operation: string;
  serviceNm: string;
  testStepRulesSequences?: any;
  updatedOn?: any;
};

type ruleObj = {
  getTestRules: ruleInfo[];
};

const CertificationTestRules = (props: any) => {
  const classes = useStyles();
  const { simulatedService } = props;
  const [userRole, setUserRole] = React.useState('');
  const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);
  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const { data, loading, refetch } = useQuery<ruleObj, {}>(GET_TEST_RULES, {});
  const [deleteTestRules] = useMutation(DELETE_TEST_RULES);
  const [test_workflowName, setWorkflowName] = React.useState('');
  const [test_operation, setOperation] = React.useState('');
  const [test_description, setDescription] = React.useState('');
  const [scenarioOperations, setScenarioOperations] = React.useState<any>([]);
  const [edit, isEdit] = React.useState(false);

  const [addTestRuleOpen, setAddTestRuleOpen] = React.useState(false);
  const [formInfo, setFormInfo] = React.useState<any>({});
  const [formData, setFormData] = React.useState<any>({});
  const { enqueueSnackbar } = useSnackbar();
  const initialState = {
    testScenarioName: '',
    workflowCode: props?.workflowCode || '',
    workflowName: '',
    stepModalOpen: false,
    description: '',
    items: [] as any,
    operations: [],
    // scenarioOperations: [],
    testDataNames: [],
    isDeleteOpen: false,
    addScenarioOpen: false,
    stepExecuteModalOpen: false,
    // isEdit: false,
    scenario: { testScenarioName: '', participantType: '', serviceNm: '' },
    scenarios: [],
    fields: [] as any,
    participantType: '',
    activeInex: '',
    rowData: { testScenarioName: '', testStepSequence: [] },
    step: '' as any,
    testScenarioExecutionSeq: [] as any,
    operationName: '',
    operationCode: ''
  };
  const [
    {
      testScenarioName,
      workflowCode,
      workflowName,
      description,
      items,
      scenarios,
      operations,
      addScenarioOpen,
      participantType,
      //   isEdit,
      scenario,
      //   scenarioOperations,
      testDataNames,
      rowData,
      stepExecuteModalOpen,
      activeInex,
      fields,
      step,
      testScenarioExecutionSeq,
      operationName,
      operationCode
    },
    setFormField
  ] = React.useState({
    ...initialState
  });

  const operationsTableActions: any = [
    //   userRole === 'APP_ADMIN' &&
    {
      icon: () => (
        <Button
          variant="outlined"
          onClick={handleAddTestRuleDialog}
          data-id="new-operation"
          id="new-operation"
          color="primary"
        >
          Add
        </Button>
      ),
      onClick: () => {},
      // isFreeAction: !isActionOnSelect,
      position: 'toolbar'
    },
    //   userRole !== 'APP_ADMIN' &&
    {
      icon: () => <Edit data-id="edit-operation" id="edit-operation" />,
      onClick: (event: any, rowData: any) => handleEditTestRules(rowData)
    },
    {
      icon: () => <Trash data-id="delete-operation" id="delete-operation" />,
      onClick: (event: any, rowData: any) => deleteTestRuleHandle(rowData)
    }
  ];

  const deleteTestRuleHandle = (rowData: any) => {
    // const payload = scenarios.filter((item: any) => item.testScenarioName !== scenario?.testScenarioName);
    const deleteObj = [
      {
        serviceNm: rowData.serviceNm,
        operation: rowData.operation
      }
    ];
    deleteTestRules({ variables: { payload: deleteObj } })
      .then((res: any) => {
        enqueueSnackbar('Test Rule deleted successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        refetch();
        return res;
      })
      .catch(error => {
        enqueueSnackbar('Unable to delete', { variant: 'error', preventDuplicate: true });
      });
  };

  const handleEditTestRules = (rowData: any) => {
    setFormData(rowData);
    setAddTestRuleOpen(true);
    isEdit(true);
    const workflow =
      workflowList.data?.workflow?.content?.filter((item: any) => item.workflowName === rowData?.serviceNm) || [];
    const operationsList = workflow[0]?.operations;
    setScenarioOperations(operationsList);
    setWorkflowName(rowData.serviceNm);
    setOperation(rowData.operation);
    setDescription(rowData.description);
    setIsDeleteOpen(true);
  };

  const handleDialogClose = () => {
    setIsDeleteOpen(false);
  };

  const handleAddTestRuleDialogClose = () => {
    setFormInfo({});
    setFormData({});
    setAddTestRuleOpen(false);
  };

  const handleAddTestRuleDialogSubmit = (formData: any) => {
    setAddTestRuleOpen(false);
  };

  const handleAddTestRuleDialog = () => {
    setFormInfo({});
    setFormData({});
    isEdit(false);
    setAddTestRuleOpen(true);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <DetailedTable
          key="CertificationTestRules"
          id="testRuleGrid"
          title="Rules"
          columns={testRulescolumns}
          data={data?.getTestRules}
          tableActions={operationsTableActions}
          showPagination
          showTopPagination
          showSpecificPage
          page={0}
        />
      )}
      <AddTestRules
        edit={edit}
        dialogOpen={addTestRuleOpen}
        formInfo={formInfo}
        formData={formData}
        handleDialogClose={handleAddTestRuleDialogClose}
        handleDialogSubmit={handleAddTestRuleDialogSubmit}
        workflowList={workflowList}
        ruleData={data}
        simulatedService={simulatedService}
        refresh={refetch}
      />
    </>
  );
};

export default CertificationTestRules;
